<template>
  <div class="tb-list-item">
    <div class="tb-list-item-meta">
      <div class="tb-list-item-meta-icon">
        <Icon :type="icon" />
      </div>
      <div class="tb-list-item-meta-content">
        <h4 class="tb-list-item-meta-title">
         {{data.applicationTitle}} {{data.versionNo}} 
        </h4>
        <div class="tb-list-item-meta-description">
          <Badge :status="releaseStatus"></Badge>
          <span>{{publishDisplay}}</span>
        </div>
      </div>
    </div>
    <div class="tb-list-item-content">
      <div class="tb-list-item-content-item">
        <span>修改时间</span>
        <p>{{data.modifyDatetimeText}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    icon() {
      return ['logo-apple', 'logo-android', 'logo-html5'][this.data.terminal || 0]
    },
    releaseStatus(){
      return this.data.isVisible ? 'success' : 'warning'
    },
    publishDisplay(){
      return this.data.isVisible ? ('发布于 ' + this.data.releaseDatetimeText) : '未发布'
    }
  },
  monuted() {
    console.log(this.$props)
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.tb-list-item {
  display: flex;
  align-items: center;
  // padding: 12px 0;

  .ivu-icon-logo-android {
    color: rgb(171, 193, 72);
  }

  .ivu-icon-logo-apple {
    color: rgb(11, 11, 10);
  }

  .ivu-icon-logo-html5 {
    color: rgb(228, 77, 38);
  }

  .tb-list-item-meta {
    display: flex;
    flex: 1 1;
    align-items: flex-start;
    font-size: 0;
    align-items: center;
  }

  .tb-list-item-meta-icon {
    font-size: 54px;
    line-height: 0;
    margin-right: 16px;
  }

  .tb-list-item-meta-title {
    margin-bottom: 4px;
    color: rgba(0, 0, 0, .65);
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }

  .tb-list-item-meta-description {
    color: rgba(0, 0, 0, .45);
    font-size: 14px;
    line-height: 22px;
  }

  .tb-list-item-content {
    display: flex;
    flex: 1 1;
    justify-content: flex-end;
    color: rgba(0, 0, 0, .45);
    font-size: 14px;

    .tb-list-item-content-item {
      text-align: right;

      p {
        margin-top: 4px;
        margin-bottom: 0;
        line-height: 22px;
      }
    }

  }
}

</style>
